import { SwitchingCategoryTypeEnum, EquipmentTypeEnum } from '@gridcon-energy/schaltungstool-backend'
import { BarTypesEnum } from '~/lib/gantt'

export enum SVGLineStyleEnum {
  BORDER = 'border',
  GLOW = 'glow',
  FILL = 'fill',
}

/**
 * Order is important
 */
export enum VoltageLevelEnum {
  KV_380 = '380',
  KV_220 = '220',
  KV_110 = '110',
  default = 'default',
}
export const VoltageColors: Record<VoltageLevelEnum, `#${string}`> = {
  [VoltageLevelEnum.KV_380]: '#ff0000', // (was) crimson
  [VoltageLevelEnum.KV_220]: '#00c800', // (was) forestgreen
  [VoltageLevelEnum.KV_110]: '#0000ff', // (was) dodgerblue
  [VoltageLevelEnum.default]: '#bf2766', // (was) mediumvioletred
} as const

export enum ColoringContextEnum {
  GANTT = 'gantt',
  SVG = 'svg',
}

export enum SwitchingColoringModeEnum {
  CATEGORY = 'category',
  PROJECT = 'project',
  VOLTAGE = 'voltage',
  EQUIPMENT_TYPE = 'equipment_type',
}

/**
 * @example
 * --color-gantt: var(--gantt-project-123)
 */
export const ColoringCtxVariable: {
  [key in ColoringContextEnum]: `--color-${key}`
} = {
  gantt: '--color-gantt',
  svg: '--color-svg',
}

/**
 * Dynamic text opacity variable that changes based on coloring mode
 * Similar to ColoringCtxVariable
 * @example
 * --text-opacity-svg: var(--svg-text-opacity-category-activated)
 */
export const SVGTextOpacityVariable = '--text-opacity-svg'

/**
 * Bar Types
 */
export const BarTypesCSSClasses: {
  [key in BarTypesEnum]: `gantt-bar--${key}`
} = {
  [BarTypesEnum.MAIN]: 'gantt-bar--main',
  [BarTypesEnum.BACKGROUND]: 'gantt-bar--background',
  [BarTypesEnum.INITIAL_PERIOD]: 'gantt-bar--initial_period',
  [BarTypesEnum.VIOLATION_PREVIOUS]: 'gantt-bar--violation_previous',
  [BarTypesEnum.VIOLATION_PARALLEL]: 'gantt-bar--violation_parallel',
  [BarTypesEnum.OVERLAP]: 'gantt-bar--overlap',
  [BarTypesEnum.OFFLINE_RANGE]: 'gantt-bar--offline_range',
  [BarTypesEnum.LIMIT_VIOLATION]: 'gantt-bar--limit_violation',
} as const

/**
 * SVG Line Styles Classes
 */
export const SVGLineStyleCSSClasses: {
  [key in SVGLineStyleEnum]: `svg-line-style-${key}`
} = {
  [SVGLineStyleEnum.BORDER]: 'svg-line-style-border',
  [SVGLineStyleEnum.FILL]: 'svg-line-style-fill',
  [SVGLineStyleEnum.GLOW]: 'svg-line-style-glow',
}

/**
 * Switching Gantt Category
 *
 * Only activated/deactivated are relevant
 */
export const SwitchingCategoryCSSClasses: {
  [key in SwitchingCategoryTypeEnum]: `switching-${key}`
} = {
  activated: 'switching-activated',
  deactivated: 'switching-deactivated',
  disabled: 'switching-disabled',
  protected: 'switching-protected',
  meta: 'switching-meta',
  bypassMode: 'switching-bypassMode',
} as const

export const TBTDailyInfoCSSClass = 'switching-info-tbt-daily'

/**
 * Settings types
 */
export type ColoringModeSettings<T> = {
  [SwitchingColoringModeEnum.CATEGORY]: Record<SwitchingCategoryTypeEnum, T>
  [SwitchingColoringModeEnum.PROJECT]: Record<'default' | number, T>
  [SwitchingColoringModeEnum.VOLTAGE]: Record<VoltageLevelEnum, T>
  [SwitchingColoringModeEnum.EQUIPMENT_TYPE]: Record<EquipmentTypeEnum, T>
}

export type LineStyleSetting = {
  color: string
  lineStyle: SVGLineStyleEnum
}

export type ColoringSettingSVG = ColoringModeSettings<LineStyleSetting>
export type ColoringSettingGantt = ColoringModeSettings<{
  color: string
  // sync: boolean
}>
